import { useState } from 'react';

import styles from '../PasswordManagement.module.less';

import {
    Alert,
    Button,
    CallToAction,
    Col,
    FormControl,
    FormikForm,
    Row
} from '$HVUI';
import { useFetch, useQuery } from '$Hooks';
import yup from '$Validation/yup';

const { object, string } = yup;

const validationSchema = object().shape({
    email: string()
        .email('Must be a valid email address.')
        .label('Email')
        .required('Required')
});

const RequestForm = props => {
    const [success, setSuccess] = useState(false);
    const query = useQuery();
    const next = query.get('next');

    const { error, loading, post, response } = useFetch(
        '/api/v2/password-reset-email/'
    );

    const handleSubmit = async values => {
        const { email } = values;
        const payload = { email };
        if (next) {
            payload.next = next;
        }
        await post(payload);
        if (response.ok) {
            setSuccess(true);
        }
    };

    const body = success ? (
        <>
            <h1>Password reset request submitted</h1>
            <p>
                An email was sent to your account. Follow the link in the email
                to set a new password.
            </p>
            <CallToAction
                text="Home"
                href="/signin"
                color="ocean"
                level="primary"
            />
        </>
    ) : (
        <>
            <h1>Forgot Your Password?</h1>
            <p>Enter your email address below to reset your password.</p>
            <FormikForm
                onSubmit={handleSubmit}
                className="Reset-request-form-wrapper"
                validationSchema={validationSchema}
            >
                <FormControl
                    disabled={loading}
                    name="email"
                    type="email"
                    label="Email"
                />
                <Button
                    {...props}
                    disabled={loading}
                    id="button-submit"
                    type="submit"
                    text="Submit"
                    level="primary"
                />
            </FormikForm>
        </>
    );

    return (
        <div className={styles['confirm-container']}>
            {!!error && (
                <Alert
                    message="Sorry, something went wrong.  Please refresh or try again later."
                    style={{ marginBottom: '1.5rem' }}
                    type="error"
                />
            )}
            <Row gutter={48} align="center">
                <Col md={12}>{body}</Col>
            </Row>
        </div>
    );
};

export default RequestForm;
